<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>UPSI Details List</strong>
        </span>
        <span style="float:right">
            <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
                [disabled]="selectedIds.length == 0" (click)="performActionOpen()">REOPEN</button>
            <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
                [disabled]="selectedIds.length == 0" (click)="performAction()">CLOSE</button>
            <a *ngIf="globals.upsiAdmin" [routerLink]="['upsidetailsadd']">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2"
                    [appHasPermission]="{'Url': '/upsiAdmin/all/add', 'method':'post', 'menu': 'UPSI Detail All'}"
                    type="button">
                    <i class="fa fa-plus"></i>&nbsp;Add UPSI Details</button>
            </a>

            <a *ngIf="!globals.upsiAdmin" [routerLink]="['upsidetailsadd']">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2"
                    [appHasPermission]="{'Url': '/upsiAdmin/individual/add?goveva=true&email=', 'method':'post', 'menu': 'UPSI Detail Individual'}"
                    type="button">
                    <i class="fa fa-plus"></i>&nbsp;Add UPSI Details</button>
            </a>
        </span>
    </div>
    <section class="card search-box">
        <div class="card-header" (click)="toggleSearchDiv()">Modify Search <span class="pull-right"><i
                    class="fa fa-filter" aria-hidden="true"></i></span> </div>
        <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">


            <!-- Date Filters Section - Top Section -->
            <div class="filter-section date-filters-top">
                <div class="search-mode-top">
                    <div class="search-mode-group">
                        <label class="form-label">Search Mode:</label>
                        <div class="radio-group-inline">
                            <div class="form-check-inline">
                                <input class="form-check-input" type="radio" id="UPSIDetailsListSearchModeOpen"
                                    [(ngModel)]="UPSIDetailsListSearchMode" name="UPSIDetailsListSearchMode"
                                    value="open" (click)="setUPSIDetailsListSearchMode('open')">
                                <label class="form-check-label" for="UPSIDetailsListSearchModeOpen">Open</label>
                            </div>
                            <div class="form-check-inline">
                                <input class="form-check-input" type="radio" id="UPSIDetailsListSearchModePublic"
                                    [(ngModel)]="UPSIDetailsListSearchMode" name="UPSIDetailsListSearchMode"
                                    value="public" (click)="setUPSIDetailsListSearchMode('public')">
                                <label class="form-check-label" for="UPSIDetailsListSearchModePublic">Public</label>
                            </div>
                            <div class="form-check-inline">
                                <input class="form-check-input" type="radio" id="UPSIDetailsListSearchModeBoth"
                                    [(ngModel)]="UPSIDetailsListSearchMode" name="UPSIDetailsListSearchMode"
                                    value="both" (click)="setUPSIDetailsListSearchMode('both')">
                                <label class="form-check-label" for="UPSIDetailsListSearchModeBoth">Both</label>
                            </div>
                        </div>
                    </div>
                    <div class="checkbox-item" *ngIf="isMakerCheckerUsed">
                        <label class="checkbox-label">Show Unapproved:</label>
                        <input type="checkbox" id="isShowUnapproved_" class="custom-checkbox"
                            [(ngModel)]="isShowUnapproved" [ngModelOptions]="{standalone:true}">
                    </div>
                    <div class="checkbox-item">
                        <label class="checkbox-label">Encrypt PAN:</label>
                        <input type="checkbox" id="isEncryptPAN_" class="custom-checkbox"
                            (change)="handleCheckboxChange()" [(ngModel)]="isShowEncryptedPAN"
                            [ngModelOptions]="{standalone:true}">
                    </div>
                </div>
                <div class="date-filters-container">
                    <div class="date-filter-item">
                        <label class="form-label">Date when shared:</label>
                        <div class="date-range-inputs" (click)="$event.stopPropagation()">
                            <div class="date-input-wrapper">
                                <span class="date-label">From:</span>
                                <app-datepicker-material [(ngModel)]="shareddate" [placeholder]="'dd-mm-yyyy'"
                                    [ngModelOptions]="{standalone: true}">
                                </app-datepicker-material>
                            </div>
                            <div class="date-input-wrapper">
                                <span class="date-label">To:</span>
                                <app-datepicker-material [(ngModel)]="shareddateTo" [placeholder]="'dd-mm-yyyy'"
                                    [ngModelOptions]="{standalone: true}">
                                </app-datepicker-material>
                            </div>
                        </div>
                    </div>
                    <div class="date-filter-item">
                        <label class="form-label">Date of entry:</label>
                        <div class="date-range-inputs" (click)="$event.stopPropagation()">
                            <div class="date-input-wrapper">
                                <span class="date-label">From:</span>
                                <app-datepicker-material [(ngModel)]="entrydate" [placeholder]="'dd-mm-yyyy'"
                                    [ngModelOptions]="{standalone: true}">
                                </app-datepicker-material>
                            </div>
                            <div class="date-input-wrapper">
                                <span class="date-label">To:</span>
                                <app-datepicker-material [(ngModel)]="entrydateTo" [placeholder]="'dd-mm-yyyy'"
                                    [ngModelOptions]="{standalone: true}">
                                </app-datepicker-material>
                            </div>
                        </div>
                    </div>
                    <div class="date-filter-item">
                        <label class="form-label">UPSI Public Date:</label>
                        <div class="date-range-inputs" (click)="$event.stopPropagation()">
                            <div class="date-input-wrapper">
                                <span class="date-label">From:</span>
                                <app-datepicker-material [(ngModel)]="upsidate" [placeholder]="'dd-mm-yyyy'"
                                    [disabled]="UPSIDetailsListSearchMode != 'public'"
                                    [ngModelOptions]="{standalone: true}">
                                </app-datepicker-material>
                            </div>
                            <div class="date-input-wrapper">
                                <span class="date-label">To:</span>
                                <app-datepicker-material [(ngModel)]="upsidateto" [placeholder]="'dd-mm-yyyy'"
                                    [disabled]="UPSIDetailsListSearchMode != 'public'"
                                    [ngModelOptions]="{standalone: true}">
                                </app-datepicker-material>
                            </div>
                        </div>
                    </div>

                    <div class="date-filter-item nature-upsi-item">
                        <label class="form-label">Nature of UPSI:</label>
                        <select [(ngModel)]="Item" class="form-control select-input"
                            [ngModelOptions]="{standalone:true}">
                            <option value='' [selected]="true">Select</option>
                            <option *ngFor="let Item of ItemList" value="{{Item._id}}">
                                {{ Item.Item}}</option>
                            <option value='null'>Other</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- Bottom Section: User and Company Filters -->
            <div class="filter-section bottom-section">
                <div class="user-filters-container">
                    <!-- <div class="user-filter-row">
                        <div class="user-filter-group">
                            <label class="form-label">Select User:</label>
                            <div class="radio-group-inline">
                                <div class="form-check-inline">
                                    <input class="form-check-input" type="radio" id="govevaSharer" [(ngModel)]="sharerType"
                                        name="sharerType" value="govevaUser" (click)="sharerList('govevaUser')">
                                    <label class="form-check-label" for="govevaSharer">Select DigiCompany Sharer</label>
                                </div>
                                <div class="form-check-inline">
                                    <input class="form-check-input" type="radio" id="upsiSharer" [(ngModel)]="sharerType"
                                        name="sharerType" value="nonGovevaUser" (click)="sharerList('nonGovevaUser')">
                                    <label class="form-check-label" for="upsiSharer">UPSI Sharer</label>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="user-filters-grid">
                        <div class="user-filter-item">
                            <label class="form-label">Sharer:</label>
                            <select class="form-control select-input" [(ngModel)]="sharerBy"
                                [ngModelOptions]="{ standalone: true }">

                                <option [ngValue]="null">Select</option>

                                <option *ngFor="let sharer of sharerListForFilterFinal" [ngValue]="sharer._id">
                                    {{ sharer.Name || (sharer.FirstName + ' ' + sharer.LastName) }}
                                </option>

                            </select>

                            <!-- <select [(ngModel)]="sharerBy" class="form-control select-input"
                                [ngModelOptions]="{standalone:true}">
                                <option value='' [selected]="true">Select</option>
                                <option *ngFor="let sharer of sharerListForFilterFinal" value="{{sharer._id}}">
                                    {{ sharer.Name || (sharer.FirstName + ' ' + sharer.LastName) }}</option>
                            </select> -->
                        </div>
                        <!-- <div class="user-filter-item" *ngIf="this.sharerType == 'govevaUser' || this.sharerType == 'nonGovevaUser'">
                            <label class="form-label">Sharer:</label>
                            <select *ngIf="this.sharerType == 'govevaUser'" [(ngModel)]="sharerBy" class="form-control select-input"
                                [ngModelOptions]="{standalone:true}">
                                <option value='' [selected]="true">Select</option>
                                <option *ngFor="let users of userlistForFilter" value="{{users._id}}">
                                    {{ users.FirstName}} {{ users.LastName}}</option>
                            </select>
                            <select *ngIf="this.sharerType == 'nonGovevaUser'" [(ngModel)]="sharerBy" class="form-control select-input"
                                [ngModelOptions]="{standalone:true}">
                                <option value='' [selected]="true">Select</option>
                                <option *ngFor="let sharer of sharerListForFilter" value="{{sharer._id}}">
                                    {{ sharer.Name}}</option>
                            </select>
                        </div> -->
                        <div class="user-filter-item">
                            <label class="form-label">Recipient:</label>
                            <!-- <select [(ngModel)]="Recipient" class="form-control select-input"
                                [ngModelOptions]="{standalone:true}">
                                <option value='' [selected]="true">Select</option>
                                <option *ngFor="let recipient of recipientListForFilter" value="{{recipient._id}}">
                                    {{ recipient.Name}}</option>
                            </select> -->
                            <select class="form-control select-input" [(ngModel)]="Recipient"
                                [ngModelOptions]="{ standalone: true }">

                                <option [ngValue]="null">Select</option>

                                <option *ngFor="let recipient of recipientListForFilter" [ngValue]="recipient._id">
                                    {{ recipient.Name }}
                                </option>

                            </select>

                        </div>
                        <div class="user-filter-item">
                            <label class="form-label">Entered by:</label>
                            <!-- <select [(ngModel)]="EnteredBy" class="form-control select-input"
                                [ngModelOptions]="{standalone:true}">
                                <option value='' [selected]="true">Select</option>
                                <option *ngFor="let users of userlistForFilter" value="{{users._id}}">
                                    {{ users.FirstName}} {{ users.LastName}}</option>
                            </select> -->
                            <select class="form-control select-input" [(ngModel)]="EnteredBy"
                                [ngModelOptions]="{ standalone: true }">

                                <option [ngValue]="null">Select</option>

                                <option *ngFor="let user of userlistForFilter" [ngValue]="user._id">
                                    {{ user.FirstName }} {{ user.LastName }}
                                </option>

                            </select>

                        </div>
                        <div class="user-filter-item">
                            <label class="form-label">Updated by:</label>
                            <!-- <select [(ngModel)]="Updatedby" class="form-control select-input"
                                [ngModelOptions]="{standalone:true}">
                                <option value='' [selected]="true">Select</option>
                                <option *ngFor="let users of userlistForFilter" value="{{users._id}}">
                                    {{ users.FirstName}} {{ users.LastName}}</option>
                            </select> -->
                            <select class="form-control select-input" [(ngModel)]="Updatedby"
                                [ngModelOptions]="{ standalone: true }">

                                <option [ngValue]="null">Select</option>

                                <option *ngFor="let user of userlistForFilter" [ngValue]="user._id">
                                    {{ user.FirstName }} {{ user.LastName }}
                                </option>

                            </select>

                        </div>
                    </div>
                </div>
            </div>


            <!-- Action Buttons -->
            <div class="row">
                <div class="col-md-12">
                    <div class="action-buttons-container">
                        <button type="button" [disabled]="response" class="btn btn-sm btn-primary btn-search"
                            (click)="searchData();">
                            <i class="fa fa-search"></i>&nbsp;Search
                        </button>
                        <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear"
                            (click)="clear()">
                            <i class="fa fa-refresh"></i>&nbsp;Clear
                        </button>
                    </div>
                </div>
            </div>


        </div>
    </section>


    <!-- START UPSI Details List Column selection dialoge -->
    <div class="modal fade modal-size-medium" id="UPSIExportColumnSelect" tabindex="-1" role="dialog"
        data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fa fa-filter"></i>
                        Select Columns to Export
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-md-12">
                        <div class="row collapse1">
                            <span class="cat__core__title">
                                Current Selection
                            </span>

                            <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                                <thead>
                                    <tr>

                                        <th>Column</th>
                                        <th>Select</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let column of this.exportColumnMap; let count=index">

                                        <td tabindex="1" style="cursor: move; width: 70%;">
                                            {{column.columnName}}
                                        </td>
                                        <td>
                                            <input id="{{'UPSIexportColumnSelect_' + column.columnIndex}}"
                                                [checked]="true" type="checkbox"
                                                (change)="selectUnselectColumn($event, column.columnIndex)">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn-sm btn btn-primary" data-dismiss="modal">
                        <i class="fa fa-save"></i>&nbsp;Save & Close</button>

                </div>
            </div>
        </div>
    </div>
    <!-- END UPSI Details List Column selection dialoge -->

    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div class="table-responsive" id="UpisDetailsListTable">
                        <!-- <pre>{{ upsiDetails | json }}</pre> -->

                        <table datatable [dtOptions]="dtUpsiDetails" [dtTrigger]="dtUpsiDetailsTrigger"
                            class="table table-hover compact cell-border  stripe" id="sharerHistorytable"
                            style="cursor: pointer;width:700px !important">
                            <thead>
                                <tr>
                                    <!-- Important Do not change the order or add any column in between -->
                                    <!-- If Necessary make sure corresponding changes are done in this.exportColumnMap & UPSIListexportColumnOrignalOrder-->
                                    <th style="width: 50px;">
                                        <input type="checkbox" (change)="toggleSelectAll($event)" />
                                    </th>
                                    <th style="min-width:100px;">Shared by</th>
                                    <th style="min-width:100px;">Recipient</th>
                                    <th style="display: none">Recipient</th>
                                    <th style="min-width:75px;">Nature of UPSI</th>
                                    <th style="min-width:300px;">Brief details of UPSI shared</th>
                                    <th style="display: none">Email Text</th>
                                    <th style="display: none">Email Subject</th>
                                    <th style="display: none">Attachment for Email</th>
                                    <th style="display: none">Mode Of Sharing</th>
                                    <th style="min-width:200px;">Purpose for Sharing</th>
                                    <th style="display: none">Date Of Initiation</th>
                                    <th style="display: none">Persons in possession of UPSI</th>
                                    <th style="min-width:95px;">When UPSI Public/Not Applicable</th>
                                    <!-- <th>Document Download option</th> -->
                                    <th style="min-width:95px;">Date and time when shared</th>
                                    <th style="min-width:95px; display: none">Date and time when shared</th>
                                    <th style="min-width:75px;">Entered by</th>
                                    <th style="display: none">Date and time of entry</th>
                                    <th style="min-width:95px;">Date and time of entry</th>
                                    <th style="min-width:75px;">Updated by</th>
                                    <th style="min-width:95px;">Date and time of updation</th>
                                    <th style="min-width:150px;">Action</th>

                                    <!-- <th>Following 6 fileds [21-26] are ment to be hidden, but only there to populate correct data in export</th> -->
                                    <th style="display: none">Date of Sharing</th>
                                    <th style="display: none">Time of Sharing</th>

                                    <th style="display: none">Date of Entry</th>
                                    <th style="display: none">Time of Entry</th>

                                    <th style="display: none">Date of Updation</th>
                                    <th style="display: none">Time of Updation</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let details of upsiDetails; let count=index"
                                    [ngClass]="{'upsi-emailed-row': details.isEmailed}" style="line-height: 25px;">

                                    <td>
                                        <input type="checkbox" [checked]="isSelected(details._id)"
                                            (change)="toggleSelection(details._id)" />
                                    </td>

                                    <td style="min-width:100px;">{{details.SharerBYName}}
                                        ("PAN/Other"-{{isShowEncryptedPAN ? '**********': details.SharerBYPan }})</td>
                                    <td style="min-width:100px;">
                                        <li *ngFor="let Recipient of details.recipientByName; ">
                                            <span style="margin-left: -9px;">
                                                {{isShowEncryptedPAN ? extractRecipient(Recipient) : Recipient}} </span>
                                        </li>
                                    </td>
                                    <td style="display: none">
                                        <span *ngFor="let Recipient of details.recipientByName; ">
                                            <span style="margin-left: -9px;"> {{Recipient}}</span>,
                                        </span>
                                    </td>
                                    <td style="min-width:75px;">
                                        {{
                                        (details.NatureofUPSI)?details.NatureofUPSI.Item:(details.OtherNatureOfUPSI)?details.OtherNatureOfUPSI:"
                                        " }}
                                    </td>
                                    <td style="min-width:300px;">{{details.TypeOfShared}}</td>
                                    <td style="display: none">{{details.EmailText}}</td>
                                    <td style="display: none">{{details.EmailSubject}}</td>
                                    <td style="display: none">{{ details.FileNameUqEmail | slice:14}}</td>
                                    <td style="display: none">{{details.modeOfSharing}}</td>
                                    <td style="min-width:200px;">{{details.purposeForSharing}}</td>
                                    <td style="display: none">
                                        <span *ngIf="details.DateOfInitiation">{{formatDate(details.DateOfInitiation, 'dd-MM-y')}}</span>

                                    </td>
                                    <td style="display: none">{{details.possessionOfUPSI}}</td>
                                    <td style="min-width:95px;">
                                        <span *ngIf="details.PublicDate">{{formatDate(details.PublicDate, 'dd-MM-y')}}
                                            <br> {{details.PublicTime}}</span>
                                    </td>
                                    <td style="min-width:95px;"><span
                                            style="display: none">{{details.SharedDate}}</span>{{formatDate(details.SharedDate, 'dd-MM-y')}} <br>
                                        {{details.SharedTime}}</td>
                                    <td style="min-width:95px;display: none">{{formatDate(details.SharedDate, 'dd-MM-y')}}
                                        <br>
                                        {{details.SharedTime}}
                                    </td>
                                    <td style="min-width:75px;">{{details.EnterBY}}</td>

                                    <!-- <td>
                                                                        <div *ngIf="details.DocumentId" class="input-group">
                                                                            <a href="{{downloadSingleFile}}{{details.DocumentId}}"
                                                                                class="btn btn-sm btn-primary">
                                                                                <span class="fa fa-download"></span></a> </div>
                                                                    </td> -->
                                    <td style="display: none">{{formatDate(details.CreatedDate, 'dd-MM-y')}} <br>
                                        {{formatDate(details.CreatedDate, 'hh:mm a')}}</td>
                                    <td style="min-width:95px;"><span style="display: none">{{formatDate(details.CreatedDate, 'yMMddHHmm')}}</span>{{formatDate(details.CreatedDate, 'dd-MM-y')}}
                                        <br> {{formatDate(details.CreatedDate, 'hh:mm:ss a')}}
                                    </td>
                                    <td style="min-width:75px;">{{details.ModifiedBy}}</td>
                                    <td style="min-width:95px;">{{formatDate(details.ModifiedDate, 'dd-MM-y')}} <br>
                                        {{formatDate(details.ModifiedDate, 'hh:mm:ss a')}} </td>
                                    <td style="min-width:150px;">

                                        <div class="input-group">

                                            <a *ngIf="(!(details.IsCheckerApproved ? details.IsCheckerApproved : false)) && isMakerCheckerUsed"
                                                (click)="approveUSPIDetail(details)" class="btn btn-sm btn-success"
                                                title="Approve USPI Detail">
                                                <span class="fa fa-check"></span>
                                            </a>&nbsp;

                                            <button type="button" *ngIf="globals.upsiAdmin"
                                                (click)="editUpsiDetails(details._id)" class="btn-sm1 btn btn-warning"
                                                [appHasPermission]="{'Url': '/upsiAdmin/all/edit', 'method':'put', 'menu': 'UPSI Detail All'}"
                                                title="Edit">
                                                <span class="fa fa-pencil"></span>
                                            </button>&nbsp;

                                            <button type="button" *ngIf="!globals.upsiAdmin"
                                                (click)="editUpsiDetails(details._id)" class="btn-sm1 btn btn-warning"
                                                [appHasPermission]="{'Url': '/upsiAdmin/individual/edit?goveva=true&email=', 'method':'put', 'menu': 'UPSI Detail Individual'}"
                                                title="Edit">
                                                <span class="fa fa-pencil"></span>
                                            </button>&nbsp;

                                            <button type="button" (click)="historyDetailsById(details._id)"
                                                class="btn-sm1 btn btn-warning" title="History">
                                                <span class="icmn-history"></span>
                                            </button>&nbsp;
                                            <button type="button" (click)="ViewEmailLog(details._id)"
                                                class="btn-sm1 btn btn-warning" title="View Email Log">
                                                <span class="fa fa-eye"></span>
                                            </button>&nbsp;
                                            <button type="button" (click)="sendUpsiDetailsMail(details,$event)"
                                                class="btn-sm btn btn-warning" title="Send Email ">
                                                <span class="fa fa-envelope"></span>
                                            </button>
                                            &nbsp;
                                            <a *ngIf="details.FileOriginalName && details.FileOriginalName.length > 0"
                                                (click)="openDownloadModal(details.FileOriginalName)"
                                                class="btn btn-sm1 btn-warning" title="Download Document">
                                                <span class="fa fa-download"></span>
                                            </a>
                                            &nbsp;
                                            <a *ngIf="details.FileNameUqEmail.length > 0"
                                                (click)="openEmailDownloadModal(details.FileNameUqEmail)"
                                                class="btn btn-sm1 btn-primary" title="Download Email Attachment">
                                                <span class="fa fa-download"></span>
                                            </a>

                                        </div>
                                    </td>

                                    <!-- HIDDEN Date of Sharing -->
                                    <td style="display: none">{{formatDate(details.SharedDate, 'dd-MM-y')}} </td>
                                    <td style="display: none">{{details.SharedTime}}</td>

                                    <!-- HIDDEN Date of Entry -->
                                    <td style="display: none">{{formatDate(details.CreatedDate, 'dd-MM-y')}} </td>
                                    <td style="display: none">{{formatDate(details.CreatedDate, 'hh:mm:ss a')}} </td>

                                    <!-- HIDDEN Date of Updation -->
                                    <td style="display: none">{{formatDate(details.ModifiedDate, 'dd-MM-y')}} </td>
                                    <td style="display: none">{{formatDate(details.ModifiedDate, 'hh:mm:ss a')}} </td>


                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal" id="deleteDetailsConfirmation" tabindex="-1" role="dialog" data-backdrop="static"
        data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        <i class="fa fa-question-circle-o mr-2"></i>&nbsp;Confirm
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            Are you sure you want to delete UPSI details?
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteDetailsById()"
                        data-dismiss="modal">
                        <i class="fa fa-check"></i>&nbsp;Yes</button>
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;No</button>
                </div>
            </div>
        </div>
    </div>


    <!-- <div class="modal" id="historyModel" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true"  style="position: fixed;
        top: 0;
        right: 40px !important;
        bottom: 0;left: -631px;width:2200px;">
        <div class="modal-dialog  modal-lg" role="document" style="width:1620px;">
            <div class="modal-content" style="width:1500px;">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        <span class="icmn-history" style="margin-right: 10px;"></span>History</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div> -->
    <div class="modal" id="historyModel" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog  modal-xl" role="document" style="max-width: 100% !important;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        <span class="icmn-history" style="margin-right: 10px;"></span>History
                    </h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">

                            <table datatable [dtOptions]="dtDetailsHistory" [dtTrigger]="dtDetailsTrigger"
                                class="table table-hover compact cell-border nowrap stripe" id="Historytable"
                                style="cursor: pointer;">
                                <thead>
                                    <tr>

                                        <th style="min-width:150px;">Operation Type</th>
                                        <th style="min-width:170px;">Operation Date and Time</th>
                                        <th style="min-width:150px;">Created By</th>
                                        <th style="min-width:150px;">Ip Address</th>
                                        <th style="min-width:150px;">Sharer Name</th>
                                        <th style="min-width:150px;">Recipient</th>
                                        <th style="min-width:150px;">Nature of UPSI</th>
                                        <th style="min-width:200px;">Brief details of UPSI shared</th>
                                        <th style="min-width:200px;">Purpose for Sharing</th>

                                        <th style="min-width:200px;">Persons in possession of UPSI</th>
                                        <th style="min-width:200px;">Mode Of Sharing</th>
                                        <th style="min-width:200px;">Email Text</th>
                                        <th style="min-width:200px;">Email Subject</th>
                                        <th style="min-width:200px;">Attachment for Email</th>
                                        <th style="min-width:200px;">Date Of Initiation</th>
                                        <th style="min-width:150px;">Shared Date</th>
                                        <th style="min-width:150px;">Shared Time</th>
                                        <th style="min-width:150px;">Public/Not Applicable Date</th>
                                        <th style="min-width:150px;">Public/Not Applicable Time</th>
                                        <!-- <th style="min-width:150px;">Created Date</th> -->
                                        <th style="min-width:150px;">Modified Date and Time</th>
                                        <th style="min-width:150px;">Modified By</th>
                                        <th style="min-width:150px;">File Uploaded</th>

                                        <th style="display:none">ODAte</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let History of detailsHistory; let count=index"
                                        style="line-height: 25px;">

                                        <td style="min-width:150px;" tabindex="1">
                                            {{(History.o == 'u')?'Update':'Insert'}}</td>
                                        <td style="min-width:170px;" tabindex="1">
                                            {{formatDate(History.t, 'dd-MM-y hh:mm a')}}
                                        </td>
                                        <td style="min-width:150px;" tabindex="1">{{History.CreatedByUserName }}</td>
                                        <td style="min-width:150px;" tabindex="1">{{History.d.IPAddress }}</td>
                                        <td style="min-width:150px;" tabindex="1">{{History.SharerBYName }}</td>
                                        <td style="min-width:150px;">
                                            <li *ngFor="let Recipient of History.recipientByName; ">
                                                {{Recipient}}
                                            </li>
                                        </td>
                                        <td style="min-width:150px;" tabindex="1">
                                            {{(History.NatureofUPSI)?History.NatureofUPSI:""}}
                                            {{ (!History.NatureofUPSI)?History.d.OtherNatureOfUPSI:""}} </td>
                                        <td style="min-width:200px;" tabindex="1">{{History.d.TypeOfShared }}</td>
                                        <td style="min-width:200px;">{{History.d.purposeForSharing}}</td>
                                        <td style="min-width:200px;">{{History.d.possessionOfUPSI}}</td>
                                        <td style="min-width:200px;">{{History.d.modeOfSharing}}</td>
                                        <td style="min-width:200px;">{{History.d.EmailText}}</td>
                                        <td style="min-width:200px;">{{History.d.EmailSubject}}</td>
                                        <td style="min-width:200px;">{{ History.d.FileNameUqEmail}}</td>
                                        <td style="min-width:200px;">
                                            <span *ngIf="History.d.DateOfInitiation">{{formatDate(History.d.DateOfInitiation, 'dd-MM-y')}}</span>

                                        </td>

                                        <td style="min-width:150px;" tabindex="1">
                                            {{formatDate(History.d.SharedDate, 'dd-MM-y') }}</td>
                                        <td style="min-width:150px;" tabindex="1">{{History.d.SharedTime }}</td>
                                        <td style="min-width:150px;" tabindex="1">
                                            <span *ngIf="History.d.PublicDate">{{formatDate(History.d.PublicDate, 'dd-MM-y')
                                                }}</span>
                                        </td>
                                        <td style="min-width:150px;" tabindex="1">{{History.d.PublicTime }}</td>
                                        <!-- <td  style="min-width:150px;" tabindex="1">{{History.d.CreatedDate |  date : "dd-MM-y HH:mm" }}</td> -->
                                        <td style="min-width:150px;" tabindex="1">
                                            {{formatDate(History.d.ModifiedDate, 'dd-MM-y hh:mm a')}}</td>
                                        <td style="min-width:150px;" tabindex="1">{{History.ModifiedBy}}</td>
                                        <td style="min-width:150px;" tabindex="1">{{History.d.backendFileName}}</td>

                                        <td style="display:none" tabindex="1">{{formatDate(History.t, 'yMMddHHmm')}}</td>



                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Ok</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade modal-size-medium" id="upsiDetailsEmailFileDownloadDialog" tabindex="-1" role="dialog"
        data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fa fa-download"></i>
                        <span id="UpsiFileDownloadTitle"></span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-md-12">
                        <div class="row collapse1">
                            <span class="cat__core__title">
                                UPSI Files
                            </span>

                            <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                                <thead>
                                    <tr>

                                        <th>Filename</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="fileNameArray">
                                    <tr *ngFor="let file of fileNameArray; let index = index">
                                        <td tabindex="1" style="cursor: move; width: 70%;">
                                            {{file.name}}
                                        </td>
                                        <td>
                                            <button type="button" class="btn-sm btn btn-warning"
                                                (click)="downloadFileEmail(file.backendName)">
                                                <span class="fa fa-download"></span>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Close</button>

                </div>
            </div>
        </div>
    </div>
    <div class="modal fade modal-size-medium" id="upsiDetailsFileDownloadDialog" tabindex="-1" role="dialog"
        data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fa fa-download"></i>&nbsp;
                        <span id="UpsiFileDownloadTitle">Attachments (Not) for Emails</span>
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="col-md-12">
                        <div class="row collapse1">
                            <span class="cat__core__title">
                                UPSI Files
                            </span>

                            <table class="table table-hover compact cell-border nowrap stripe" style="cursor: pointer;">
                                <thead>
                                    <tr>

                                        <th>Filename</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="fileNameArray">
                                    <tr *ngFor="let file of fileNameArray; let index = index">
                                        <td tabindex="1" style="cursor: move; width: 70%;">
                                            {{file.name}}
                                        </td>
                                        <td>
                                            <button type="button" class="btn-sm btn btn-warning"
                                                (click)="downloadFileBase(file.backendName)">
                                                <span class="fa fa-download"></span>
                                            </button>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn-sm btn btn-default" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Close</button>

                </div>
            </div>
        </div>
    </div>


</section>
<app-alert></app-alert>